// frontend/src/StoreLocator/Notices.jsx — dated messages on the store pages: "Tent Sale today!", "Special Hours", "Visit Pelé!"
import React, { useState } from 'react';
import { Select, TextField } from '@shopify/polaris';
import { StatusPill } from '../ui';
import { Alert, useList } from '../GiftCards/common';
import { slApi } from './apiClient';
import ScopePicker from './ScopePicker';
import DateField from './DateField';
import { STYLES, scopeText, span } from './common';

const blank = () => ({ title: '', message: '', style: 'notice', scope: 'all', tag: '', location_id: null, shows_from: '', shows_until: '' });
const STATE = { live: ['Live', 'ful'], scheduled: ['Scheduled', 'hold'], ended: ['Ended', 'neu'] };

export default function Notices({ ctx }) {
  const { data, error, reload } = useList(() => slApi.notices(), []);
  const [form, setForm] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const edit = (n) => setForm(n ? { ...n, shows_until: n.shows_until || n.shows_from } : blank());
  const save = async (thenPublish) => {
    setBusy(true); setErr('');
    const body = { ...form, shows_until: form.shows_until || form.shows_from };
    try {
      const r = form.id ? await slApi.updateNotice(form.id, body) : await slApi.addNotice(body);
      setForm(null); reload();
      if (thenPublish) { const p = await slApi.publish({}); ctx.notify(`Saved; full publish #${p.id} started`); } else ctx.notify(r.publish_id ? 'Saved; pushing the affected stores to the sites now' : 'Saved');
    } catch (e) { setErr(e.message); } finally { setBusy(false); }
  };
  const remove = async (n) => { if (!window.confirm(`Remove "${n.title}"?`)) return; try { await slApi.removeNotice(n.id); reload(); ctx.notify('Removed; pushing the affected stores to the sites now'); } catch (e) { ctx.notify(e.message); } };
  const notices = (data && data.notices) || [];
  return (
    <div className="uh-card">
      <div className="uh-ia-tbar">
        <span className="uh-ia-hint">A notification is a message on the store pages and in the map list, for one store, all stores or a tag, between two dates. It never changes the hours: pair a "Special hours" notification with a rule on that tab.</span>
        <span className="uh-sp" /><button type="button" className="uh-btn primary" onClick={() => edit(null)}>Add notification</button>
      </div>
      <div className="uh-card-b">
        <Alert>{error}</Alert>
        {form && (
          <div className="uh-form-card uh-sl-form">
            <div className="uh-ia-frow">
              <TextField label="Title" value={form.title} placeholder="Tent Sale today!" autoComplete="off" onChange={(v) => setForm({ ...form, title: v })} />
              <Select label="Style" value={form.style} onChange={(v) => setForm({ ...form, style: v })} options={[{ value: 'notice', label: 'Notice (red: hours, closures)' }, { value: 'promo', label: 'Promo (accent colour: sales, events)' }, { value: 'info', label: 'Info (plain)' }]} />
              <ScopePicker value={form} onChange={setForm} tags={ctx.meta && ctx.meta.tags} />
              <DateField label="Show from" value={form.shows_from} onChange={(v) => setForm({ ...form, shows_from: v, shows_until: form.shows_until && form.shows_until >= v ? form.shows_until : v })} />
              <DateField label="Until" value={form.shows_until} min={form.shows_from} onChange={(v) => setForm({ ...form, shows_until: v })} />
              <div className="uh-span2"><TextField label="Message" value={form.message} multiline={2} placeholder="Doors open at 9. Cleats, jerseys and balls out front at up to 70% off." autoComplete="off" onChange={(v) => setForm({ ...form, message: v })} /></div>
            </div>
            {err && <div className="uh-ia-bad">{err}</div>}
            <div className="uh-ia-row"><button type="button" className="uh-btn primary" disabled={busy} onClick={() => save(false)}>Save</button><button type="button" className="uh-btn" disabled={busy} onClick={() => save(true)}>Save and publish everything</button><button type="button" className="uh-btn" disabled={busy} onClick={() => setForm(null)}>Cancel</button></div>
          </div>
        )}
        <div className="uh-tscroll"><table className="uh-tbl">
          <thead><tr><th>Title</th><th>Message</th><th>Applies to</th><th>Shown</th><th>Style</th><th>Status</th><th /></tr></thead>
          <tbody>
            {notices.map((n) => {
              const [sl, st] = STYLES[n.style] || [n.style, 'neu']; const [label, tone] = STATE[n.state] || [n.state, 'neu'];
              return (
                <tr key={n.id} className={n.state === 'ended' ? 'uh-ia-old' : ''}>
                  <td><b>{n.title}</b></td><td>{n.message}</td><td>{scopeText(n)}</td><td>{span(n.shows_from, n.shows_until)}</td>
                  <td><StatusPill tone={st}>{sl}</StatusPill></td><td><StatusPill tone={tone}>{label}</StatusPill></td>
                  <td className="uh-ia-nowrap"><button type="button" className="uh-btn slim" onClick={() => edit(n)}>Edit</button> <button type="button" className="uh-btn slim" onClick={() => remove(n)}>Remove</button></td>
                </tr>
              );
            })}
            {data && notices.length === 0 && <tr><td colSpan={7} className="uh-empty">No notifications yet.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
